import { render, staticRenderFns } from "./CostTemplateDetail.vue?vue&type=template&id=0e8ac8b1&scoped=true"
import script from "./CostTemplateDetail.vue?vue&type=script&lang=js"
export * from "./CostTemplateDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CostTemplateDetail.vue?vue&type=style&index=1&id=0e8ac8b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8ac8b1",
  null
  
)

export default component.exports